<template>
  <ErrorModal v-if="hasModalError" />
  <div class="main-tag">
    <div style="min-height: 90vh" class="row mt-5">
      <div class="col-md-4 offset-md-4 col-sm-8 offset-sm-2 text-left q-pt-xl">
        <h4 class="welcome-heading-text q-mb-sm q-pt-lg">
          {{ t("mfa.instructions") }}
        </h4>
        <div class="row q-mb-lg">
          <div class="col-md-12">
            <strong>{{ t("mfa.download_app") }}</strong>
            <br />
            <br />
            <a :href="t('mfa.download_ios_link')" target="_blank">
              {{ t("mfa.download_ios") }}
            </a>
            <br />

            <a :href="t('mfa.download_android_link')" target="_blank">
              {{ t("mfa.download_android") }}
            </a>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-12">
            <strong>{{ t("mfa.scan_qr") }}</strong>
            <br />
            <br />
            <vue-qrcode :value="qr" type="'image/png'" />

            <q-form @submit="submitSetup" class="q-gutter-md">
              <div class="row q-pt-sm">
                <div class="col-md-6">
                  <q-input
                    v-model="code"
                    bg-color="white"
                    :label="t('mfa.input_result')"
                    dense
                    outlined
                    stack-label
                    autofocus
                  />
                </div>
              </div>
              <div class="q-pt-sm q-pb-lg">
                <q-btn
                  :label="t('mfa.verify_code')"
                  type="submit"
                  class="mfa-btn bold-font"
                  no-caps
                  color="#0a1f8f"
                />
              </div>
            </q-form>
            <div>
              <p>
                {{ t("mfa.no_scan") }}
              </p>
              <p>
                <strong>{{ t("mfa.key") }}</strong>
                <br />
                <code> {{ sharedKey }} </code>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import store from "../store/index.js";
import { useRouter } from "vue-router";
import axios from "axios";
import axiosUrl from "../services/axios.service";
import { useI18n } from "vue-i18n";
import VueQrcode from "vue-qrcode";
import authService from "../services/auth.service";
import ErrorModal from "./ErrorModal.vue";

const API_URL = axiosUrl.getAxiosUrl();

export default {
  name: "MfaSetup",
  components: {
    VueQrcode,
    ErrorModal,
  },
  setup() {
    store.commit("auth/setIsLoggedIn", false);
    const { t } = useI18n();
    const router = useRouter();
    const sharedKey = ref("");
    const qr = ref("");
    const code = ref("");

    const hasModalError = computed({
      get: () => store.state.auth.hasModalError,
    });

    const submitSetup = async () => {
      const returnUrl = router.currentRoute.value.query.returnUrl || "";
      await axios
        .post(
          API_URL + "/MFA/mfasetupcode",
          {
            code: code.value,
          },
          {
            params: {
              returnUrl: returnUrl,
            },
          },
        )
        .then(async () => {
          await authService.getAuthUserData(true, returnUrl).then(async () => {
            await authService.handleLoginRedirect();
          });
        })
          .catch(() => {
          store.commit("auth/updateModalError", "MFA code incorrect");
          store.commit("auth/enableModalError");
          code.value = "";
        });
    };

    onMounted(async () => {
      await axios.get(API_URL + "/MFA/mfasetup").then((response) => {
        sharedKey.value = response.data.key.match(/.{1,4}/g).join(" ");
        qr.value = response.data.qr;
      })
        .catch((error) => {
          store.commit("auth/updateModalError", error.response.data);
          store.commit("auth/enableModalError");
          router.go(-1);
      });
    });

    return {
      t,
      router,
      sharedKey,
      qr,
      submitSetup,
      hasModalError,
      code,
    };
  },
};
</script>
<style>
.ptl {
  padding-top: 100px;
}
</style>
